import { getEnv } from "./utils";

const dev = {
  // aws: {
  //   invokeUrl:'https://n34smpuqk9.execute-api.eu-west-1.amazonaws.com',
  //   accessKey: 'AKIAIUVYODFQB7OMOILQ',
  //   secretKey: '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',
  //   apiKey: 'I41QElC9gr3d2Bgii8JWeFqIzxeQPVp8jTfFNC2j',
  //   region: 'eu-west-1'
  // },
  // orderApi: "/alexuat1/order/"
  aws: {
    invokeUrl:'https://n34smpuqk9.execute-api.eu-west-1.amazonaws.com',
    accessKey: 'AKIA6BGZPW56AT4IR34D',
    secretKey: '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',
    apiKey: 'I41QElC9gr3d2Bgii8JWeFqIzxeQPVp8jTfFNC2j',
    region: 'eu-west-1'
  },
  orderApi: "/alexuat1/order/"
};

const prod = {
  aws: {
    invokeUrl:'https://i4iuahxtsd.execute-api.eu-west-1.amazonaws.com',
    accessKey: 'AKIA6BGZPW56AT4IR34D',
    secretKey: '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',
    apiKey: 'I41QElC9gr3d2Bgii8JWeFqIzxeQPVp8jTfFNC2j',
    region: 'eu-west-1'
  },
  orderApi: "/prod/order/"
};

const configuration = getEnv() === "development" ? dev : prod;

const config = {
  appVersion: "1.0.1",
  appName: "customer tracker",
  appDescription: "",
  ...configuration,
};

export default config;
